import type { Product, ProductVariant } from "@/mocks/products";

// "Dourado / P" a partir dos valores da variação ({ Cor: "Dourado", Tamanho: "P" }).
export function variantLabel(values: Record<string, string> | undefined): string | undefined {
  const parts = Object.values(values ?? {}).filter(Boolean);
  return parts.length > 0 ? parts.join(" / ") : undefined;
}

// Foto da variação (a que o lojista vinculou na Nuvemshop); sem foto própria,
// usa a foto principal do produto.
export function variantImage(product: Product, variant: ProductVariant | null | undefined): string {
  if (variant?.imageId && product.imageIds && product.images) {
    const index = product.imageIds.indexOf(variant.imageId);
    if (index >= 0 && product.images[index]) return product.images[index];
  }
  return product.image;
}

export function defaultVariant(product: Product): ProductVariant | undefined {
  return product.variants?.find((entry) => entry.id === product.variantId);
}

// Quantidade máxima que dá pra comprar da variação (estoque), ou undefined se a
// loja não controla estoque dela.
export function variantMaxQuantity(variant: ProductVariant | null | undefined): number | undefined {
  return typeof variant?.stock === "number" ? Math.max(0, variant.stock) : undefined;
}

// Legenda da variação que vai pra sacola quando o produto é adicionado direto
// da vitrine (a variação padrão, a primeira com estoque).
export function defaultVariantLabel(product: Product): string | undefined {
  const variant = product.variants?.find((entry) => entry.id === product.variantId);
  return variant && (product.variants?.length ?? 0) > 1 ? variantLabel(variant.values) : undefined;
}
